// extracted by mini-css-extract-plugin
export var tosLink = "_4s-0";